import Vue from 'vue';
if(document.getElementById('questionnaire')){
    let questionnaire = new Vue({
        el: '#questionnaire',
        data: {
            confidentiality: true
        }
    });
}